<template>
  <div class="solution-menu">
    <template v-for="(item, i) in items">
      <SolutionsButton 
        :key="'button' + i" 
        :item="item" 
        :isActive="selected == item.name" 
        @setActive="setActive(item.name)"
        @toggleActive="toggleActive(item.name)"
      ></SolutionsButton>

      <SolutionsContent 
        :key="'content' + i"
        :item="item" 
        :isActive="selected == item.name"
      ></SolutionsContent>
    </template>
  </div>
</template>

<script>
import SolutionsButton from './SolutionsButton';
import SolutionsContent from './SolutionsContent';

export default {
  name: "RaHubSolutions",
  components: {
    SolutionsButton,
    SolutionsContent,
  },

  props: {
    items: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      selected: 'Koalas Forever',
    }
  },

  methods: {
    setActive(name) {
      this.selected = name;
    },
    toggleActive(name) {
      this.selected !== name ? this.selected = name : this.selected = '';
    }
  }
};
</script>

<style scoped>
.solution-menu {
  display: grid;
  grid-template: repeat(4, auto) / 1fr;
  margin-bottom: 2rem;
}

@media only screen and (min-width: 768px) {
  .solution-menu {
    grid-template: auto auto / repeat(4, 1fr);
  }
}
</style>


// WEBPACK FOOTER //
// RaHubSolutions.vue?aa260528